// extracted by mini-css-extract-plugin
export default {"moreInChat":"ScrollButton_moreInChat__EMxMf","moreInChatHidden":"ScrollButton_moreInChatHidden__8qd-c","scrollBtn":"ScrollButton_scrollBtn__+Cgve"};